import { CmsLinkComponent } from '@cms/components/cmsLink/CmsLink'
import type { CmsLinkList } from '@cms/types/cmsLinkList'
import { GenericAccordion } from '@/content/components/genericAccordion'
import type { FooterPropsApi } from '../models'

export const FooterLinks = (props: FooterPropsApi) => {
    const { footerFirstTitle, footerFirstBox, footerSecondTitle, footerSecondBox, footerThirdTitle, footerThirdBox, footerFourthTitle, footerFourthBox } = props

    function generateFooterBox(links: CmsLinkList, title?: string) {
        const footerLinks = <ul>
            {
                links.map((item, index) => {
                return (
                    <li key={index}>
                        <CmsLinkComponent link={item} />
                    </li>
                )
            })}
        </ul>
        return (
            <div className="footer_box">
                <div className="footer_box__title">
                    {title && (<p className="footer_box__title__text">{title}</p>)}
                    {footerLinks}
                </div>
                {title && (<GenericAccordion collapseIcon={'chevron-up'} expandIcon={'chevron-down'} header={title} headerLevel={'div'} isDefaultOpen={false} extraClass={'footer--link_accordion'}>
                    {footerLinks}
                </GenericAccordion>)}
            </div>
        )
    }
    
    return (
        <div className="footer--link_container container-lg-padding accordion">
            {footerFirstBox && (generateFooterBox(footerFirstBox, footerFirstTitle))}
            {footerSecondBox && (generateFooterBox(footerSecondBox, footerSecondTitle))}
            {footerThirdBox && (generateFooterBox(footerThirdBox, footerThirdTitle))}
            {footerFourthBox && (generateFooterBox(footerFourthBox, footerFourthTitle))}
        </div>
    )
}
